import React, { useContext, useEffect, useMemo } from "react";
import { RiContexts, RiProvider } from "../right.context";
import RiHeaderContainer from "../component/riHeaderContainer.part";
import RiRecommendation from "../component/ri-recommendation.part";
import RightSizing from "../component/rightsizing.part";
import { useRiRecommendationStatis } from "@/services/rightRecommendation/header-recommendation.repo";
import { useNavigate } from "react-router-dom";
import RiHeader from "../component/ri-header.part";

export default function AZureRiScreenComponent() {
  return (
    <RiProvider>
      <AwsRiScreens />
    </RiProvider>
  );
}

const AwsRiScreens = ({ service = "azure" }) => {
  const context = useContext(RiContexts);

  const query = useMemo(() => {
    const tags = (context?.selectedTags || []).filter(
      (e) => e.filterOn.length > 0 && e.values.length > 0
    );
    return {
      service,
      // rightSizing: {
      //   accounts: context?.selectedAccounts?.length
      //     ? context.selectedAccounts.map((e) => e.id)
      //     : undefined,
      //   resourceGroupName:
      //     context?.selectedResourceGroup?.length > 0 &&
      //     context?.selectedResourceGroup?.length
      //       ? context.selectedResourceGroup.map((e) => e.id)
      //       : undefined,
      //   regions: context?.selectedRegions?.length
      //     ? context.selectedRegions.map((e) => e.id)
      //     : undefined,
      //   tags: tags.length ? tags : undefined,
      // },
      // ri: {
      //   accounts:
      //     context?.selectedAccounts &&
      //     (context?.selectedAccounts || []).map((e) => e.id),
      //   region:
      //     context?.selectedRegions &&
      //     (context?.selectedRegions || []).map((e) => e.id),
      //   instance:
      //     context?.SelecInstanceTypents &&
      //     (context?.SelecInstanceTypents || []).map((e) => e.id),
      //   platform:
      //     context?.SelectedplateformType &&
      //     (context?.SelectedplateformType || []).map((e) => e.id),
      // },
      type:context?.eventkey
    };
  }, [context?.eventkey, context?.selectedTags, service]);

  const { data, isLoading, error } = useRiRecommendationStatis(query);

  const accountName = "Subscription";
  const instType = "Instance Type";
    const navigate = useNavigate();
  
  useEffect(()=>{
    // console.log("eventkey",context?.eventkey)
    context?.setSelectedAccount([])
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  },[context?.eventkey])
  return (
    <div>
      <RiHeader data={data} isLoading={isLoading} error={error} />

      {context?.eventkey === "RI Recommendations" && (
        <RiRecommendation
          service={service}
          accountName={accountName}
          instType={instType}
        />
      )}
      {context?.eventkey === "Rightsizing" && (
        <RightSizing
        service="azure"
        name="Subscription Name"
        resource="ResourceId"
        />
      )}
    </div>
  );
};
